export default function Process() {
  const steps = [
    {
      number: 1,
      title: 'Initial Consultation',
      description: 'Technical advisory to understand your needs and project scope'
    },
    {
      number: 2,
      title: 'Technical Inspection',
      description: 'Comprehensive site evaluation and measurement verification'
    },
    {
      number: 3,
      title: 'Formal Proposal',
      description: 'Detailed quote with materials, timeline, and investment breakdown'
    },
    {
      number: 4,
      title: 'Logistical Planning',
      description: 'Strategic scheduling and material procurement coordination'
    },
    {
      number: 5,
      title: 'Professional Execution',
      description: 'Expert installation with minimal disruption to operations'
    },
    {
      number: 6,
      title: 'Delivery Audit',
      description: 'Final walkthrough and quality assurance inspection'
    }
  ];

  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <div className="flex items-center space-x-2 mb-4">
            <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
            <p className="text-sm font-semibold text-gray-600 uppercase tracking-wider">OUR PROCESS</p>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-2">From Consultation to Completion</h2>
          <p className="text-3xl font-serif italic text-[#2E5C8A]">Seamless Execution</p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute top-12 left-0 right-0 h-1 bg-[#FF6B35]"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
            {steps.map((step) => (
              <div key={step.number} className="relative">
                <div className="flex flex-col items-center text-center">
                  <div className="w-24 h-24 flex items-center justify-center bg-[#FF6B35] rounded-full text-white text-3xl font-bold mb-6 relative z-10 shadow-lg">
                    {step.number}
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 bg-gray-50 rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#2E5C8A] rounded-full mx-auto mb-4">
                <i className="ri-time-line text-3xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-800 mb-2">Flexible Scheduling</h4>
              <p className="text-sm text-gray-600">Strategic phasing to maintain your operations during installation</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35] rounded-full mx-auto mb-4">
                <i className="ri-tools-line text-3xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-800 mb-2">Turnkey Service</h4>
              <p className="text-sm text-gray-600">Complete lifecycle management from planning to final inspection</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gray-400 rounded-full mx-auto mb-4">
                <i className="ri-customer-service-line text-3xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-800 mb-2">Post-Sale Support</h4>
              <p className="text-sm text-gray-600">Technical maintenance guides to maximize surface lifespan</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
